import Image from "next/image";
import Link from "next/link";
import React from "react";

const Cta = ({ data, targetAmount, amountRaised }) => {
  console.log("This is the amount ", data);
  return (
    <div>
      {/* <!-- CTA --> */}

      <div className="container py-10">
        <div className="relative overflow-hidden rounded-2.5xl px-16 pt-16 pb-8 shadow-md lg:px-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_dark.jpg"
              alt="gradient dark"
              className="h-full w-full object-cover"
            />
          </picture>
          <div className="items-center justify-between md:flex">
            <div className="mb-6 md:w-1/2">
              <h2 className="mb-4 font-display text-2xl text-jacarta-700 dark:text-white sm:text-3xl">
                Amount Raised:{" "}
              </h2>
              <h2 className="mb-4 font-display text-2xl text-jacarta-700 dark:text-white sm:text-3xl">
                <span className="text-accent">
                  ${parseFloat(amountRaised ?? 0).toFixed(2)}
                </span>
              </h2>
              {/* <p className="mb-8 text-lg dark:text-jacarta-300">
                  Our support heroes will have you up and running in less than
                  10mins.
                </p> */}
              <div className="mb-2 flex justify-between dark:text-jacarta-300">
                <span>
                  Raised:{" "}
                  <span className="text-green">
                    ${parseFloat(targetAmount ?? 0).toFixed(2)}
                  </span>
                </span>
                <span>
                  Target: <span>{targetAmount}</span>
                </span>
              </div>
              <div className="rounded bg-accent-lighter">
                <div
                  className="h-4 rounded bg-accent"
                  style={{
                    width:
                      "" +
                      (parseFloat(amountRaised ?? 0).toFixed(2) /
                        targetAmount) *
                        100 +
                      "%",
                  }}
                />
              </div>
            </div>
            <Link
              href="/contact"
              className="mt-4 inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
            >
              CREATE IMPACT TOKEN FOR THIS CAMPAIGN
            </Link>
            {/* <Image
              width={340}
              height={300}
              src="/images/crypto-consultant/cta_illustration.png"
              alt="cta_illustration"
            /> */}
          </div>
        </div>
      </div>

      {/* <!-- end cta --> */}
    </div>
  );
};

export default Cta;
